import apiClient from './apiClient';
const URL = process.env.REACT_APP_API_URL + "/coordinadores";

export const getCoordinadores = async () => {
    try {
        const response = await apiClient(URL, {
            method: "GET",
            headers: {
                "Content-Type": "application/json"
            }
        });
        const data = await response.json();
        if (response.status !== 200) {
            throw new Error(data.message || "Error al obtener las areas temáticas");
        }
        return data
    } catch (error) {
        throw error
    }
}


export const postCoordinador = async (coordinador) => {
    try {
        const response = await apiClient(URL, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({ ...coordinador })
        });
        const data = await response.json();
        if (response.status !== 201) {
            throw new Error(data.message || "Error al crear el coordinador");
        }
        return data
    } catch (error) {
        throw error
    }
}
